module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area",
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('el-timeline', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "reverse": false
    }
  }, _vm._l((_vm.records), function(record, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "timestamp": record.createTime
      }
    }, [_vm._v("\n          " + _vm._s(record.statusDesc) + "\n        ")])
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-331c05c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ResumeRecords.vue
// module id = 258
// module chunks = 1